import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Truck } from "lucide-react";

export const Navbar = () => {
  const navigate = useNavigate();
  return (
    <header
      data-testid="top-navbar"
      className="sticky top-0 z-40 w-full border-b border-[#1a1a1a]/10 bg-white/90 backdrop-blur"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 lg:px-8 h-16">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
          <span className="grid place-items-center h-9 w-9 rounded-lg bg-[#ff6b35] text-white shadow-sm group-hover:bg-[#ff8c42] transition-colors">
            <Truck size={20} strokeWidth={2.5} />
          </span>
          <span className="font-display font-extrabold text-lg text-[#1a1a1a] tracking-tight">
            Come Pick Up My Trash
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#333]">
          <a href="/#pricing" data-testid="nav-pricing" className="hover:text-[#ff6b35] transition-colors">
            Pricing
          </a>
          <a href="/#how" data-testid="nav-how" className="hover:text-[#ff6b35] transition-colors">
            How it works
          </a>
          <a href="/#area" data-testid="nav-area" className="hover:text-[#ff6b35] transition-colors">
            Service area
          </a>
          <Link to="/faq" data-testid="nav-faq" className="hover:text-[#ff6b35] transition-colors">
            FAQ
          </Link>
        </nav>
        <Button
          data-testid="nav-book-btn"
          onClick={() => navigate("/book")}
          className="bg-[#ff6b35] hover:bg-[#ff8c42] text-white font-bold rounded-lg shadow-sm"
        >
          Book Now
        </Button>
      </div>
    </header>
  );
};

export default Navbar;
